import * as z from "zod";

export const getLinkedMerchantPhone = {
  name: "getLinkedMerchantPhone" as const,
  input: z.null(),
  output: z.object({ phoneE164: z.string().nullable() }),
};
